module.exports = __webpack_public_path__ + "img/33.b2d85252.jpg";